export default "__VITE_ASSET__Bkz63jwC__"